'use client';

import { useBrandStore } from '@/entities/brand/model/use-brand-store';
import { Link } from '@/i18n/navigation';
import { Container, HStack, IconButton } from '@chakra-ui/react';
import { FiSearch } from 'react-icons/fi';
import { GoArrowLeft } from 'react-icons/go';
import BrandSelectMobile from './BrandSelectMobile';
import { IBranch } from '@/_types';

interface RestaurantHeaderProps {
  branch: IBranch | null;
}

const HeaderFixed = ({ branch }: RestaurantHeaderProps) => {
  return (
    <Container px={2} bg='white'>
      <HStack justify='space-between' py='2'>
        <Link href='/where-to-go'>
          <IconButton aria-label='Back' variant='ghost' rounded='xl'>
            <GoArrowLeft strokeWidth='0.75' />
          </IconButton>
        </Link>

        <BrandSelectMobile brandName={branch?.name || ''} />
        <div></div>
{/* 
        <Link href={`/brand-search?restaurant=${branch?.id}`}>
          <IconButton aria-label='Search' variant='ghost' rounded='xl'>
            <FiSearch />
          </IconButton>
        </Link> */}
      </HStack>
    </Container>
  );
};

export default HeaderFixed;
